/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Track_Merge_HelpInputs */



/**
* | output |
* | --- |
* | "Optionally assign the events from each group to a track (A-D)." |
*
* @param {Event_Track_Merge_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_track_merge_help = /** @type {((inputs?: Event_Track_Merge_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Track_Merge_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Il est possible d'attribuer les événements de chaque groupe à une piste (A-D).")
	if (locale === "de") return /** @type {LocalizedString} */ ("Optional können die Ereignisse aus jeder Gruppe einem Track (A-D) zugeordnet werden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("È possibile assegnare, facoltativamente, gli eventi di ciascun gruppo a una traccia (A-D).")
	if (locale === "ru") return /** @type {LocalizedString} */ ("При желании можно присвоить событиям из каждой группы отдельную дорожку (A-D).")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opcionalmente, asigne los eventos de cada grupo a una pista (A-D).")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("（可选）将每组事件分配到赛道（A-D）。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("必要に応じて、各グループのイベントをトラック（A～D）に割り当ててください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आप चाहें तो प्रत्येक समूह की घटनाओं को एक ट्रैक (A-D) में असाइन कर सकते हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opcionalmente, atribua os eventos de cada grupo a uma faixa (A-D).")
	return /** @type {LocalizedString} */ ("Optionally assign the events from each group to a track (A-D).")
});